import type { Resource } from '../../';
export const header_navigation_close: Resource = {"default":"Close Navigation"};
